"use client";

import { useSyncExternalStore } from "react";

const subscribe = () => () => {};

/** The structured-data script of a page. It is written into the page the server sends (what search engines read) but not when the browser builds the page itself while moving between pages, where React refuses scripts. */
export function JsonLdScript({ json }: { json: string }) {
  const fromServer = useSyncExternalStore(subscribe, () => false, () => true);
  return fromServer ? <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} /> : null;
}
